module.exports = __webpack_public_path__ + "img/AFMS_BB_FN.dea0d710.png";